<script setup lang="ts">
import { usePejer } from '@/Pejer'
import { Card } from 'pejer/src/components/ui/card'
import { cn } from 'pejer/src/lib/utils'
import { ref, watch } from 'vue'
import DNB from './BankExamples/DNB.vue'
import OtherBank from './BankExamples/OtherBank.vue'

const props = defineProps<{
  businessName: string
  organizationId: string
  countryCode: string
  bban: string

  contactPostalCode: string
  contactPersonName: string
  contactPersonEmail: string
}>()

const emits = defineEmits<{
  (e: 'accountCreated'): void
  (e: 'update:finished', value: boolean): void
}>()

const selectedBank = ref<string | null>(null)
watch(selectedBank, (newValue) => {
  if (newValue == 'DNB') emits('update:finished', true)
})

const pejer = usePejer()
</script>
<template>
  <div>
    <div class="flex flex-col gap-6">
      <div class="flex flex-col">
        <span class="text-slate-500 text-sm">Bedrift:</span>
        <div class="flex flex-col">
          <h3 class="font-bold">{{ businessName || 'loading' }}</h3>
          <span class="text-slate-500 text-sm">
            Organisasjonsnummer: {{ organizationId || 'loading' }}
          </span>
        </div>
      </div>
      <div>
        Velg bank:
        <div class="w-fit flex flex-col gap-2">
          <Card
            :class="
              cn('p-2 flex hover:bg-slate-50 cursor-pointer w-full max-w-80 min-w-24', {
                'border border-cyan-500': selectedBank === 'DNB',
              })
            "
            @click="
              () => {
                selectedBank = 'DNB'
              }
            "
          >
            <div class="flex flex-col">
              <h3>DNB</h3>
            </div>
          </Card>
          <Card
            :class="
              cn('p-2 flex hover:bg-slate-50 cursor-pointer w-full max-w-80 min-w-24', {
                'border border-cyan-500': selectedBank === 'Annen bank',
              })
            "
            @click="
              () => {
                selectedBank = 'Annen bank'
              }
            "
          >
            <div class="flex flex-col">
              <h3>Annen bank</h3>
            </div>
          </Card>
          <!-- <span class="text-slate-500 text-sm">Vi støtter foreløpig ikke Annen bank</span> -->
        </div>
      </div>
      <div
        class="flex flex-col gap-6 transition-opacity duration-200 max-w-[800px]"
        :class="{
          ' opacity-0 pointer-events-none': !selectedBank,
        }"
      >
        <DNB v-if="selectedBank === 'DNB'" />
        <OtherBank
          v-else-if="selectedBank === 'Annen bank'"
          :business-name="businessName"
          :organization-id="organizationId"
          :country-code="countryCode"
          :bban="bban"
          :contact-postal-code="contactPostalCode"
          :contact-person-name="contactPersonName"
          :contact-person-email="contactPersonEmail"
          @update:finished="emits('update:finished', $event)"
        />
      </div>
    </div>
  </div>
</template>
